<template>
  <div
    @mouseover="hovering = true"
    @mouseleave="hovering = false"
    style="min-width: 100px;"
  >
    <label v-show="!question.is_list && fieldType.text !== null">
      <span v-html="fieldType.text"></span>
      <v-icon
        v-if="fieldType.required"
        size="10"
        color="red"
        style="vertical-align:middle;padding-left: 10px;"
      >
        mdi-asterisk
      </v-icon>
    </label>
    <div class="input-group">
      <v-dialog
        v-if="displayDatePicker"
        v-model="displayDatePicker"
        persistant
        transition="scale-transition"
        width="290"
      >
        <v-date-picker
          no-title
          @input="value = arguments[0]"
        >
          <v-spacer/>
          <v-btn
            color="primary"
            dark
            @click="displayDatePicker = false;save()"
          >
            OK
          </v-btn>
          <v-spacer/>
        </v-date-picker>
      </v-dialog>
      <v-text-field
        v-model="value"
        v-bind:background-color="(answer.status === 'follow up' || highlightNoAnswer) ? '#ffffcc' : 'white'"
        :rules="isRequired ? [v => !!v || 'Required'] : []"
        :disabled="readonly"
        :aria-label="fieldType.text || question.text"
        browser-autocomplete="off"
        prepend-icon="date_range"
        label="Date"
        @click:prepend="displayDatePicker = !displayDatePicker"
        @focus="focus"
        @blur="save"
      >
        <v-icon
          v-if="answer.status"
          slot="prepend"
        >
          {{ statusIconClass }}
        </v-icon>
      </v-text-field>
      <slot></slot>
    </div>
    <TryAgain
      v-if="failed"
      :message="'Save'"
      @try="save"
    />
  </div>
</template>

<script>
import answerMixin from './answermixin'
import TryAgain from './TryAgain'

export default {
  name: 'DateAnswer',
  mixins: [answerMixin],
  props: [ 'readonly' ],
  components: { TryAgain },
  data () {
    return {
      failed: false,
      menu: false,
      displayDatePicker: false,
      datePickerDate: '',
      value: '',
      savedValue: '',
    }
  },
  beforeMount () {
    this.value = this.answer.date || ''
    this.datePickerDate = this.answer.date
  }
}
</script>

<style>
.follow-up input {
  background-color: #ffffcc;
}
</style>
